import React, { FC, PropsWithChildren, createContext } from 'react'
import { LocalInscriptionEscrow } from '@/utils/types/inscription'
export const LocalEscrowsContext = createContext<any>(null)

const LocalEscrowsManager: FC<PropsWithChildren> = (props) => {
	const [localEscrows, setLocalEscrows] = React.useState<LocalInscriptionEscrow[]>()

	return (
		<LocalEscrowsContext.Provider value={{ localEscrows, setLocalEscrows }}>
			{props.children}
		</LocalEscrowsContext.Provider>
	)
}

export default LocalEscrowsManager
